module.exports = __webpack_public_path__ + "static/TT-Plans-Outdoor_Spaces-ca3fd781e2e94e163277fe25a1257bca.pdf";